module.exports = __webpack_public_path__ + "img/TvDip-Logo_dark.10e4e1.svg";